import React from "react";
import "./ShadowLoader.css";

export const ShadowLoader = () => {
  return <div id="cover-spin"></div>;
};
